module.exports = __webpack_public_path__ + "static/media/user-circle-outline.56a752d2.svg";